import {FilterRange} from "@/instantsearch/filter/FilterRange";
import {useTranslations} from "@/hooks/useTranslations";
import {useConfigContext} from "@/ConfigProvider";
import {useEffect, useRef} from "react";
import {DynamicWidgets, useInstantSearch} from "react-instantsearch";
import {FilterCheckboxList} from "@/instantsearch/filter/FilterCheckboxList";
import {FilterColor} from "@/instantsearch/filter/FilterColor";
import ResetFilters from "@/instantsearch/components/ResetFilters";
import {SearchBox} from "@/instantsearch/components/SearchBox";
import AisActiveRefinements from "@/instantsearch/components/ais-active-refinements";

export function FilterArea() {
    const tc = useTranslations();
    const {algoliaConfig: {isSearch}, algoliaRefinements: {hasRefinements, refinementList}} = useConfigContext();
    const {uiState} = useInstantSearch();
    const uiStateRef = useRef(uiState);

    useEffect(() => {
        uiStateRef.current = uiState;
    }, [uiState]);

    return (

        <div className={"ais-filterArea"}>
            <header className={"ais-filterArea__header"}>
                <ResetFilters/>
                <AisActiveRefinements/>
            </header>
            <section className={"ais-filterArea__content"}>
                {isSearch && (
                    <>
                        {
                           <SearchBox/>
                        }
                    </>
                )}
                {hasRefinements ? (
                    <div>
                        <DynamicWidgets>
                            {refinementList.map((item) => {
                                if (item.display_type == 3) {
                                    return <FilterRange
                                        key={item.name}
                                        attribute={item.name}
                                        title={item.description}
                                        labelApply={tc.apply}
                                        labelReset={tc.reset}
                                        precision={item.data_type === 2 ? 2 : 0}
                                    />;
                                } else if (item.display_type == 9) {
                                    return (
                                        <FilterColor
                                            key={item.name}
                                            attribute={item.name}
                                            title={item.description}
                                            limit={8}
                                            showMore={true}
                                            showMoreLimit={100}
                                            sortBy={["name:asc"]}
                                            operator={item.multiple_choices == 1 ? "or" : "and"}
                                        />
                                    );
                                } else {
                                    return (
                                        <FilterCheckboxList
                                            key={item.name}
                                            attribute={item.name}
                                            title={item.description}
                                            limit={8}
                                            showMore={true}
                                            showMoreLimit={100}
                                            sortBy={["name:asc"]}
                                            operator={item.multiple_choices == 1 ? "or" : "and"}
                                        />
                                    );
                                }
                            })}
                        </DynamicWidgets>
                    </div>
                ) : null}
            </section>
        </div>
    );
}
